<template>
  <FormLayout title="Jobs found at multiple locations" @on-dismiss="handleDismiss">
    <vs-wrapper class="px-5">
      <location-card
        v-for="location in locationKeys"
        :key="location"
        :location-id="location"
        :job-count="jobsGroupedByLocation[location].length"
        :link-to="{
          name: 'fvnext-info-panel',
          params: { id: location, source: 'locations' },
        }"
      />
    </vs-wrapper>
  </FormLayout>
</template>

<script setup lang="ts">
import LocationCard from './LocationCard.vue'
import FormLayout from '../common/FormLayout.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import { computed } from 'vue'

const props = defineProps<{
  title?: string
  jobsGroupedByLocation: { [locationId: string]: (string | number)[] }
}>()

const locationKeys = computed(() => Object.keys(props.jobsGroupedByLocation))

const emits = defineEmits<{
  (e: 'dismiss')
}>()

const handleDismiss = () => {
  emits('dismiss')
}
</script>
